export default __webpack_public_path__ + "images/assets/c4cf4536524c72826d804d6e59aa1b8b.svg";